export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq0-Intro.2a4c5aaa.png";